export default "query {\n  demoDyApi {\n    fruit\n    dyCampaign {\n      variationId\n      decisionId\n    }\n  }\n}\n"